<template>
  <div class="ggu-offer twentytwo">
    <!--offer获得-->
    <div class="harvest">
      <div class="title-bar">
        <div class="left">
          <i class="iconfont icon-biaoqian"></i>世毕盟学员<b>仅</b>2026
          FALL的部分录取
        </div>
        <div class="right">数据更新至 {{ times }}</div>
      </div>
      <div class="tips">以下录取案例，均实名制备案，接受学员和家长的监督!</div>

      <div class="list">
        <ul class="clear">
          <li v-for="(item, index) in OfferCountList" :key="index">
            <div class="logo">
              <img :src="GetSrc(item.title)" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="count">{{ item.count }}</div>
          </li>
        </ul>
      </div>
    </div>

    <!--世毕盟学员历年录取offer数（北大神校）：-->
    <div class="harvest">
      <div class="title-bar">
        <div class="left">
          <i class="iconfont icon-biaoqian"></i
          >世毕盟学员历年录取offer数（八大神校）：
        </div>
      </div>
      <div class="allList">
        <ul class="clear">
          <li v-for="(item, index) in allOfferCount" :key="index">
            <div class="logo">
              <img :src="GetSrc(item.title)" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="count">{{ item.num }}枚</div>
          </li>
          <p class="all_count">
            合计：<span>{{ allCount }}枚</span>
          </p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
const imgUrl = "http://www.gguconsulting.com/Public/img/";
import api from "@/api/offer";
export default {
  data() {
    return {
      imgUrl,
      wxImg:
        "http://www.gguconsulting.com/try/sbm/Public/img/offer_share_2025.jpg",
      OfferCountList: [
        {
          count: "23",
          title: "Harvard",
        },
        {
          count: "11",
          title: "MIT",
        },
        {
          count: "9",
          title: "Princeton",
        },
        {
          count: "16",
          title: "Stanford",
        },
        {
          count: "41",
          title: "Berkeley",
        },
        {
          count: "98",
          title: "CMU",
        },
        {
          count: "10",
          title: "Oxford",
        },
        {
          count: "9",
          title: "Cambridge",
        },
      ],
      allOfferCount: [
        {
          num: "439",
          serial_number: "1",
          title: "哈佛大学",
        },
        {
          num: "509",
          serial_number: "2",
          title: "麻省理工学院",
        },
        {
          num: "488",
          serial_number: "3",
          title: "斯坦福大学",
        },
        {
          num: "268",
          serial_number: "4",
          title: "普林斯顿大学",
        },
        {
          num: "840",
          serial_number: "5",
          title: "加州大学伯克利分校",
        },
        {
          num: "155",
          serial_number: "6",
          title: "加州理工学院",
        },
        {
          num: "278",
          serial_number: "7",
          title: "牛津大学",
        },
        {
          num: "320",
          serial_number: "8",
          title: "剑桥大学",
        },
      ], //历年录取offer数
      allCount: 3297,
      times: "",
    };
  },
  methods: {
    //获取当天时间
    getTime() {
      var curDate = new Date();
      var stringDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000);
      stringDate.setTime(stringDate.getTime());
      this.times =
        stringDate.getFullYear() +
        "." +
        (stringDate.getMonth() + 1) +
        "." +
        stringDate.getDate();
    },
    //offer获得学习logo
    GetSrc(type) {
      switch (type) {
        case "Harvard":
          return require("../../assets/img/logo1.png");
        case "MIT":
          return require("../../assets/img/logo2.png");
        case "Princeton":
          return require("../../assets/img/logo3.png");
        case "Stanford":
          return require("../../assets/img/logo4.png");
        case "Berkeley":
          return require("../../assets/img/logo5.png");
        case "Caltech":
          return require("../../assets/img/logo6.png");
        case "Oxford":
          return require("../../assets/img/logo7.png");
        case "Cambridge":
          return require("../../assets/img/logo8.png");
        case "CMU":
          return require("../../assets/img/logo9.png");

        case "哈佛大学":
          return require("../../assets/img/logo1.png");
        case "麻省理工学院":
          return require("../../assets/img/logo2.png");
        case "普林斯顿大学":
          return require("../../assets/img/logo3.png");
        case "斯坦福大学":
          return require("../../assets/img/logo4.png");
        case "加州大学伯克利分校":
          return require("../../assets/img/logo5.png");
        case "加州理工学院":
          return require("../../assets/img/logo6.png");
        case "牛津大学":
          return require("../../assets/img/logo7.png");
        case "剑桥大学":
          return require("../../assets/img/logo8.png");
      }
    },
  },
  created() {
    this.getTime();
    this.WXConfig.wxShowMenu(
      "2025世毕盟offer龙虎榜",
      "更好录取 有目共睹",
      "http://www.gguconsulting.com/try/sbm/index.php/#/offer",
      this.wxImg
    );
  },
};
</script>

<style lang="less" scoped>
.ggu-offer {
  padding: 20px 0 50px;
}
//offer获得
.harvest {
  width: 100%;
  background: #fff;
  border-radius: 20px 20px 0px 0px;
  margin-top: 20px;
  .title-bar {
    height: 80px;
    border-bottom: 1px solid #f7f7f7;
    line-height: 80px;
    .left {
      float: left;
      i {
        width: 16px;
        height: 21px;
        font-size: 28px;
        margin: 0 15px 0 30px;
        color: #000;
        display: inline-block;
      }
      font-size: 30px;
      color: #000;
      font-weight: 600;
      b {
        color: #2a62d1;
        border-bottom: 4px solid #2a62d1;
      }
    }
    .right {
      float: right;
      font-size: 22px;
      color: #999;
      margin-right: 25px;
    }
  }
  .tips {
    font-size: 26px;
    color: #b13143;
    margin: 21px 28px 26px;
  }
  .list {
    margin: 0 26px;
    padding-bottom: 17px;
    border-bottom: 1px solid #f7f7f7;
    li {
      width: calc(~"(100% - 54px) / 4");
      height: 174px;
      float: left;
      background: rgba(198, 50, 50, 0.1);
      margin: 0 18px 16px 0;
      border-radius: 10px;
      text-align: center;
      // font-family:"PingFang SC";
      .logo {
        width: 67px;
        height: 66px;
        border-radius: 50%;
        margin: 18px auto 5px auto;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .name {
        font-size: 24px;
        color: #333;
      }
      .count {
        font-size: 32px;
        font-weight: 600;
        color: #b82624;
      }
      &:nth-child(4n) {
        margin-right: 0px;
      }
      &:last-child {
        background: rgba(213, 89, 104, 0.1);
        .count {
          color: rgba(213, 89, 104, 1);
        }
      }
      &:nth-child(2) {
        background: rgba(198, 50, 50, 0.1);
        .count {
          color: rgba(198, 50, 50, 1);
        }
        img {
          background: url("../../assets/img/logo2.png");
        }
      }
      &:nth-child(3) {
        background: rgba(221, 131, 34, 0.1);
        .count {
          color: rgba(221, 131, 34, 1);
        }
      }
      &:nth-child(4) {
        background: rgba(156, 50, 50, 0.1);
        .count {
          color: rgba(156, 50, 50, 1);
        }
      }
      &:nth-child(5) {
        background: rgba(25, 63, 137, 0.1);
        .count {
          color: rgba(25, 63, 137, 1);
        }
      }
      &:nth-child(6) {
        background: rgba(243, 149, 48, 0.1);
        .count {
          color: rgba(243, 149, 48, 1);
        }
      }
      &:nth-child(7) {
        background: rgba(38, 58, 96, 0.1);
        .count {
          color: rgba(38, 58, 96, 1);
        }
      }
    }
  }
  .allList {
    margin: 25px 26px 0;
    padding-bottom: 17px;
    border-bottom: 1px solid #f7f7f7;
    li {
      margin-bottom: 16px;
      background: rgba(198, 50, 50, 0.1);
      border-radius: 10px;
      display: flex;
      align-items: center;
      padding: 15px 40px 15px 20px;
      box-sizing: border-box;
      &:nth-child(3n) {
        margin-right: 0px;
      }
      .logo {
        width: 67px;
        height: 66px;
        border-radius: 50%;
        margin-right: 20px;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .name {
        font-size: 26px;
        color: #333;
        flex: 1;
      }
      .count {
        width: 200px;
        font-size: 32px;
        font-weight: 600;
        color: #b82624;
        text-align: right;
      }
      &:nth-child(2) {
        background: rgba(198, 50, 50, 0.1);
        .count {
          color: rgba(198, 50, 50, 1);
        }
        img {
          background: url("../../assets/img/logo2.png");
        }
      }
      &:nth-child(3) {
        background: rgba(156, 50, 50, 0.1);
        .count {
          color: rgba(156, 50, 50, 1);
        }
      }
      &:nth-child(4) {
        background: rgba(221, 131, 34, 0.1);
        .count {
          color: rgba(221, 131, 34, 1);
        }
      }
      &:nth-child(5) {
        background: rgba(25, 63, 137, 0.1);
        .count {
          color: rgba(25, 63, 137, 1);
        }
      }
      &:nth-child(6) {
        background: rgba(243, 149, 48, 0.1);
        .count {
          color: rgba(243, 149, 48, 1);
        }
      }
      &:nth-child(7) {
        background: rgba(38, 58, 96, 0.1);
        .count {
          color: rgba(38, 58, 96, 1);
        }
      }
      &:nth-child(8) {
        background: rgba(213, 89, 104, 0.1);
        .count {
          color: rgba(213, 89, 104, 1);
        }
      }
    }
    .all_count {
      font-size: 28px;
      color: #000;
      font-weight: 600;
      text-align: right;
      padding-right: 40px;
      span {
        font-size: 32px;
      }
    }
  }
}
</style>